import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';

type Phase = 'idle' | 'submitting' | 'done';

export function CoachSignupPage() {
  const [phase, setPhase] = useState<Phase>('idle');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [firmName, setFirmName] = useState('');
  const [phone, setPhone] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setPhase('submitting');
    setErrorMsg('');
    try {
      await httpsCallable(getFunctions(), 'signupAsCoach')({
        name: name.trim(),
        email: email.trim(),
        firmName: firmName.trim() || null,
        phone: phone.trim() || null,
      });
      setPhase('done');
    } catch (err: any) {
      setErrorMsg(err?.message ?? 'Something went wrong. Please try again.');
      setPhase('idle');
    }
  };

  return (
    <div style={outerStyle}>
      <div className="card" style={{ width: 420, textAlign: 'center' }}>
        <div style={{ fontSize: 28, fontWeight: 800, letterSpacing: '0.04em', color: 'var(--accent-text)', marginBottom: 6 }}>
          KLARR
        </div>
        <div style={{ fontSize: 12, color: 'var(--text-secondary)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 32 }}>
          Coach Application
        </div>

        {phase === 'done' ? (
          <p style={{ fontSize: 14, color: 'var(--text-primary)', lineHeight: 1.7 }}>
            Thanks — we'll review your application and be in touch.
          </p>
        ) : (
          <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
            <div className="form-group" style={{ marginBottom: 16 }}>
              <label className="form-label">Name</label>
              <input className="form-input" type="text" value={name}
                onChange={e => setName(e.target.value)} disabled={phase === 'submitting'} required />
            </div>
            <div className="form-group" style={{ marginBottom: 16 }}>
              <label className="form-label">Email</label>
              <input className="form-input" type="email" value={email}
                onChange={e => setEmail(e.target.value)} disabled={phase === 'submitting'} required />
            </div>
            <div className="form-group" style={{ marginBottom: 16 }}>
              <label className="form-label">
                Firm name{' '}
                <span style={{ color: 'var(--text-secondary)', fontWeight: 400 }}>(optional)</span>
              </label>
              <input className="form-input" type="text" value={firmName}
                onChange={e => setFirmName(e.target.value)} disabled={phase === 'submitting'} />
            </div>
            <div className="form-group" style={{ marginBottom: 24 }}>
              <label className="form-label">
                Phone number{' '}
                <span style={{ color: 'var(--text-secondary)', fontWeight: 400 }}>(optional)</span>
              </label>
              <input className="form-input" type="tel" value={phone}
                onChange={e => setPhone(e.target.value)} disabled={phase === 'submitting'} />
            </div>
            {errorMsg && <div className="error-message" style={{ marginBottom: 16 }}>{errorMsg}</div>}
            <button className="btn-primary" type="submit" disabled={phase === 'submitting'}
              style={{ width: '100%', padding: '11px 20px', fontSize: 14 }}>
              {phase === 'submitting' ? '…' : 'Apply to join'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

const outerStyle: React.CSSProperties = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'var(--bg-primary)',
};
